export default "__VITE_ASSET__A9I3SJ17__"